var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Header1'),_c('v-main',[_c('v-container',{staticStyle:{"max-width":"800px"},attrs:{"ma-0":_vm.isMobileDevice,"pa-0":_vm.isMobileDevice}},[_c('router-view'),_c('Footer1')],1)],1),_c('UserInterface4NotificationList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }